import React from "react";
import reports from "../../data/Reports.json";
import abstracts from "../../data/Abstracts.json";
import "../../styles/Articles.css";
import { useState, useEffect } from "react";

const ReportsAndAbstracts = () => {
  const [reportsData, setReports] = useState({ reports: [] });
  const [abstractsData, setAbstracts] = useState({ abstracts: [] });
  const [error, setError] = useState(null);

  useEffect(() => {
    try {
      setReports(reports);
      setAbstracts(abstracts);
    } catch (err) {
      setError(err.message);
    }
  }, []);

  if (error) return <p>Error: {error}</p>;
  if (!reportsData || !abstractsData) return <p>Loading...</p>;

  return (
    <div className="articles-list">
      <h2>Reports</h2>
      <div className="articles">
        <ol>
          {reportsData.reports.map((entry, index) => (
            <li key={index}>{entry}</li>
          ))}
        </ol>
      </div>
      <h2>Journal Abstracts</h2>
      <div className="articles">
        <ol>
          {abstractsData.abstracts.map((entry, index) => (
            <li key={index}>{entry}</li>
          ))}
        </ol>
      </div>
    </div>
  );
};

export default ReportsAndAbstracts;
